import { httpAPI } from "@/api/httpAPI";

const npa = {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        category: '-1',
        statuses: [
            { category: '-1', value: '1' },
            { category:  '0', value: new Date().getFullYear().toString() },
            { category:  '1', value: new Date().getFullYear().toString() },
            { category:  '2', value: new Date().getFullYear().toString() },
        ],
        substatuses: [
            { category:  '0', value: "-1" },
            { category:  '1', value: "-1" },
            { category:  '2', value: "-1" },
        ],
        tableSearchs: [],
        updateCounterInProcess: false,
        counts: [
            { category: '-1', value: 0 },
            { category:  '0', value: 0 },
            { category:  '1', value: 0 },
            { category:  '2', value: 0 },
        ]
    }),
    mutations: {
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_CATEGORY (state, payload) {
            state.category = payload;
        },
        SET_STATUS (state, payload) {
            let exists = state.statuses.find(x => x.category == state.category);

            if (exists)
                exists.value = payload;
            else
                state.statuses.push({category:state.category, value:payload});
        },
        SET_SUBSTATUS (state, payload) {
            let exists = state.substatuses.find(x => x.category == state.category);

            if (exists)
                exists.value = payload;
            else
                state.substatuses.push({category: state.category, value: payload});
        },
        SET_TABLE_SEARCH (state, payload) {
            let exists = state.tableSearchs.find(x => x.category == state.category);

            if (exists)
                exists.value = payload;
            else
                state.tableSearchs.push({category:state.category, value:payload});
        },
        SET_UPDATE_IN_PROCESS(state, payload) {
            state.updateCounterInProcess = payload;
        },
        SET_COUNT(state, payload){
            let exists = state.counts.find(x => x.category == payload.category);
            if (exists)
                exists.value = payload.value;
            else
                state.counts.push(payload);
        }
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getCategory: (s) => s.category,
        getStatus: (s) => s.statuses.find(x => x.category === s.category)?.value,
        getSubstatus: (s) => s.substatuses.find(x => x.category === s.category)?.value,
        getTableSearch: (s) => s.tableSearchs.find(x => x.category === s.category)?.value,
        getProjectsCount: (s) => s.counts.find(x => x.category === '-1')?.value ?? 0,
        getSolutionsCount: (s) => s.counts.find(x => x.category === '0')?.value ?? 0,
        getResolutionsCount: (s) => s.counts.find(x => x.category === '1')?.value ?? 0,
        getOrdersCount: (s) => s.counts.find(x => x.category === '2')?.value ?? 0,
    },
    actions:{
        async updateCounter({commit, state}) {
            if (!state.updateCounterInProcess) {
                commit('SET_UPDATE_IN_PROCESS', true);
                try
                {
                    let response = await httpAPI({
                        url: `api/npa/counter`,
                        method: 'GET',
                    });

                    if (response?.data?.Payload?.data && Array.isArray(response?.data?.Payload?.data) && response?.data?.Payload?.data.length >= 4 ) {
                        commit('SET_COUNT', { category: "-1", value: response?.data?.Payload?.data[3] ?? 0});
                        commit('SET_COUNT', { category:  "0", value: response?.data?.Payload?.data[0] ?? 0});
                        commit('SET_COUNT', { category:  "1", value: response?.data?.Payload?.data[1] ?? 0});
                        commit('SET_COUNT', { category:  "2", value: response?.data?.Payload?.data[2] ?? 0});
                    }
                }
                finally
                {
                    commit('SET_UPDATE_IN_PROCESS', false);
                }
            }
        }
    }
}

export default npa;